export enum ESuffix {
  singular = '',
  plural = '_pl',
}
